module.exports = __webpack_public_path__ + "static/media/sprite_flower-blue.389cd7f2.svg";